import { ApiProblemError } from '@taler/api-client'

/** The server's own detail message when there is one, so a validation reason survives to the UI. */
export function problemDetail(error: Error | null): string | undefined {
  return error instanceof ApiProblemError ? error.problem.detail : undefined
}

/** The backend refused on a missing capability, e.g. `ACCOUNT_ARCHIVE` for a non-owner deleting a contact. */
export function isCapabilityDenied(error: Error | null): boolean {
  return error instanceof ApiProblemError && error.code === 'ledger.capability_denied'
}
